/**
 * Amount in px header should overlap with content on Nonprofit page
 */
export const NONPROFIT_PAGE_HEADER_OVERLAP_HEIGHT = 78;
export const NONPROFIT_PAGE_HEADER_OVERLAP_HEIGHT_L = 200;
